import api from '../api'
const BaseUrl = '/university/api/AdminCourse'
const moocIssuanceCertificate = {
  issuanceCertificateTable(params) {
    return api.post(`${BaseUrl}//CourseLicensePeopleTable`, params)
  },
  applyCertificate(params) {
    return api.post(`${BaseUrl}/ApplyLicense`, params)
  },
  downloadCertificate(id) {
    return api.get(`${BaseUrl}/GetCourseLicense/id?id=${id}`)
  },
}

export default moocIssuanceCertificate
